export default "__VITE_ASSET__1d41fb2c__"